'use strict';
angular.module('reporting.dashboards.services')
    .factory('reporting.dashboards.services.sideBarService', [
    '$rootScope',
    'eventManager',
    '$timeout',
    function ($rootScope, eventManager, $timeout) {
        var _window = $(window);
        var sidebarState = {
            isClosed: true
        };
        return {
            closeSideBar: function () {
                var scrollTop = $('#results-page').scrollTop();
                var headerOffset = $('#results-toolbar').scrollTop() + 150;
                var classToAdd = scrollTop > headerOffset ?
                    'hidden-fixed-sidebar' : 'hidden-fixed-sidebar-home';
                $('#widget-options-panel')
                    .removeClass('hidden-fixed-sidebar fixed-sidebar fixed-sidebar-home hidden-fixed-sidebar-home')
                    .addClass(classToAdd);
                if (!sidebarState.isClosed) {
                    $('section.container').css({ 'width': '101%' });
                    $('.dashboard-sidebar').css({ 'width': '0px' });
                    eventManager.publish('resetSelectedWidget');
                    $timeout(function () {
                        _window.trigger('resize');
                        sidebarState.isClosed = true;
                    });
                }
            },
            restoreSideBar: function () {
                var scrollTop = $('#results-page').scrollTop();
                var headerOffset = $('#results-toolbar').scrollTop() + 150;
                $('.dashboard-sidebar').css({ 'width': '270px' });
                var classToAdd = scrollTop > headerOffset ?
                    'fixed-sidebar' : 'fixed-sidebar-home';
                $('#widget-options-panel')
                    .removeClass('hidden-fixed-sidebar fixed-sidebar fixed-sidebar-home hidden-fixed-sidebar-home')
                    .addClass(classToAdd);
                if (sidebarState.isClosed) {
                    $('section.container').removeAttr('style');
                    $timeout(function () {
                        _window.trigger('resize');
                        sidebarState.isClosed = false;
                    });
                }
            },
            jumpToTop: function () {
                $('#widget-options-panel')
                    .removeClass('fixed-sidebar fixed-sidebar-home')
                    .addClass('hidden-fixed-sidebar-home');
                $('section.container').css({ 'width': '101%' });
                $('.dashboard-sidebar').css({ 'width': '0px' });
                eventManager.publish('resetSelectedWidget');
                $('.q-container').scrollTop('0');
                $timeout(function () {
                    _window.trigger('resize');
                    sidebarState.isClosed = true;
                });
            },
            decreaseSideBarTop: function () {
                $('#widget-options-panel')
                    .removeClass('fixed-sidebar-home')
                    .addClass('fixed-sidebar');
            },
            increaseSideBarTop: function () {
                $('#widget-options-panel')
                    .removeClass('fixed-sidebar')
                    .addClass('fixed-sidebar-home');
            }
        };
    }
]);
